import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { TIER, tierLs } from './license$';


type PROVIDER = {
    title: string;
    description: string;
};

export class License {
    id: string;
    subscriptionId: string;
    tier: TIER;
    isB2B: boolean;
    isB2C: boolean;
    cancelDate: Date | null;
    customerId: string;
    productId: string;
    provider?: PROVIDER;

    constructor(
        private coords: CoordinatorService,
        {
            subscriptionId,
            customerId,
            productId,
            tier,
            b2b,
            b2c,
            scheduled,
            provider
        }: {
            subscriptionId?: string;
            customerId?: string;
            productId?: string;
            tier: TIER;
            b2b?: boolean;
            b2c?: boolean;
            scheduled?: { action: string; effective_at: string; resume_at?: string };
            provider?: PROVIDER;
        },
    ) {
        this.subscriptionId = subscriptionId ?? '';
        this.id = subscriptionId || this.coords.uniqueId();
        this.customerId = customerId ?? '';
        this.productId = productId ?? '';
        this.tier = tier ?? 'free';
        provider && (this.provider = provider);
        this.isB2B = b2b ?? false; // Fixed: changed isB2B to b2b
        this.isB2C = b2c ?? false; // Fixed: changed isB2C to b2c
        this.cancelDate = scheduled?.action === 'cancel' ? new Date(scheduled.effective_at) : null;
    }

    get title() {
        if (this.provider) {
            return this.provider.title;
        }
        return this.coords.text("Personal");
    }

    get description() {
        if (this.provider) {
            return this.provider.description;
        }
        return this.coords.text("Personal_license_desc");
    }

    get indicatorText() {
        return this.coords.text(this.tier);
    }

    get indicatorClass() {
        return this.tier;
    }

    get isCanceled() {
        return this.cancelDate !== null;
    }

    // Operator to compare licenses based on tier
    static compare(
        licenseA: License | null | undefined,
        licenseB: License | null | undefined,
    ): boolean {
        const tierOrder = tierLs;
        const tierAIndex = licenseA ? tierOrder.indexOf(licenseA.tier) : -1;
        const tierBIndex = licenseB ? tierOrder.indexOf(licenseB.tier) : -1;
        return tierAIndex >= tierBIndex;
    }
}
